import {
  Component,
  Inject,
  Input,
  OnInit,
  forwardRef
} from '@angular/core';

import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { NgbActiveModal }     from '@ng-bootstrap/ng-bootstrap';

import { ApiService }      from '../../app-lite/api/api.service';
import { InvoiceModel }    from '../../app-lite/invoices/models/invoice';
import { MessagesService } from '../../app-lite/messages/messages.service';

@Component({
  selector   : 'wor-invoice-analysis',
  template: require('./invoice.analysis.component.html')
})
export class InvoiceAnalysisComponent implements OnInit {
  public analysis : any = {};

  @BlockUI('invoiceAnalysisBlock') block : NgBlockUI;

  @Input() invoice : InvoiceModel;

  constructor (
    public activeModal     : NgbActiveModal,
    @Inject(forwardRef(() => ApiService)) private apiService     : ApiService,
    @Inject(forwardRef(() => MessagesService)) private messagesService: MessagesService
  ) {}

  ngOnInit () {
    this.block.start();

    this.apiService.get('/invoices/analyse_invoice', this.invoice.id)
    .then(( analysis ) => {
      this.analysis = analysis;
    })
    .catch(( err ) => {
      this.messagesService.error(err);
    })
    .finally(() => {
      this.block.stop();
    });
  }
}
